<template>
    <div class="mv-mitglieder-functions">
        <h3>Funktionen</h3>
        <p>Filterbezogene Funktionen</p>
        <template v-for="(func, key) in functions">
            <b-dropdown
                v-if="!!func.options"
                variant="outline-primary"
                class="btn-block"
                :key="key"
                :disabled="func.disabled || func.isBusy"
                :size="size"
            >
                <template v-slot:button-content>
                    <b-spinner v-if="func.isBusy" small label="Loading..." />
                    {{ func.name }}
                </template>
                <b-dropdown-item
                    v-for="option in func.options"
                    :key="option.key"
                    @click="func.action(key, option.key)"
                    >{{ option.text }}</b-dropdown-item
                >
            </b-dropdown>
            <b-button
                v-else
                :key="key"
                :disabled="func.disabled || func.isBusy"
                :size="size"
                variant="outline-primary"
                block
                @click="func.action(key)"
            >
                <b-spinner v-if="func.isBusy" small label="Loading..." />
                {{ func.name }}
            </b-button>
        </template>
        <hr />
        <p>Allgemeine Funktionen</p>
        <template v-for="(func, key) in generalFunctions">
            <b-dropdown
                v-if="!!func.options"
                variant="outline-primary"
                class="btn-block"
                :key="key"
                :disabled="func.disabled || func.isBusy"
                :size="size"
            >
                <template v-slot:button-content>
                    {{ func.name }}
                    <b-spinner v-if="func.isBusy" small label="Loading..." />
                </template>
                <b-dropdown-item
                    v-for="option in func.options"
                    :key="option.key"
                    @click="func.action(key, option.key)"
                    >{{ option.text }}</b-dropdown-item
                >
            </b-dropdown>
            <b-button
                v-else
                :key="key"
                :disabled="func.disabled || func.isBusy"
                :size="size"
                variant="outline-primary"
                block
                @click="func.action(key, func.type)"
            >
                <b-spinner v-if="func.isBusy" small label="Loading..." />
                {{ func.name }}
            </b-button>
        </template>
        <NewsletterModal :filter="filter" />
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory";
import { BlobUtil } from "@/utils/BlobUtil";
import NewsletterModal from "@/components/Newsletter/NewsletterModal";
import Toaster from "@/mixins/Toaster/Toaster";

const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    name: "MitgliederFunctions",
    mixins: [Toaster],
    prop: ['filterInit'],
    components: {
        NewsletterModal
    },
    data() {
        return {
            fields: null,
            filter: null,
            functions: {
                newsletter: {
                    name: "Newsletter versenden",
                    disabled: false,
                    action: this.selectNewsletter
                },
                mitgliederliste: {
                    name: "Mitgliederliste drucken",
                    disabled: false,
                    isBusy: false,
                    action: this.printMitgliederliste,
                    options: [
                        {
                            key: "p",
                            text: "Hochformat"
                        },
                        {
                            key: "l",
                            text: "Querformat"
                        }
                    ]
                },
                mitgliederausweis: {
                    name: "Mitgliederausweise drucken",
                    disabled: false,
                    isBusy: false,
                    action: this.printMitgliederausweise,
                    options: []
                },
                honorarbescheinigung: {
                    name: "Honorarbescheinigungen drucken",
                    disabled: false,
                    isBusy: false,
                    action: this.printHonorarbescheinigungen,
                    options: []
                },
                excel: {
                    name: "Download (Export / Excel)",
                    disabled: false,
                    isBusy: false,
                    action: this.downloadExport,
                    options: [
                        {
                            key: "xlsx",
                            text: "Excel (XLSX)"
                        },
                        {
                            key: "xls",
                            text: "Excel (XLS)"
                        },
                        {
                            key: "ods",
                            text: "OpenOffice (ODS)"
                        },
                        {
                            key: "csv",
                            text: "Kommagetrennt (CSV)"
                        }
                    ]
                }
            },
            generalFunctions: {
                geburstagsListe: {
                    name: "Geburtstagsliste drucken",
                    disabled: false,
                    type: "birthday",
                    isBusy: false,
                    action: this.printAnniversary
                },
                rundeGeburtstagsListe: {
                    name: "Runde Geburtstagsliste drucken",
                    disabled: false,
                    type: "round",
                    isBusy: false,
                    action: this.printAnniversary
                },
                jubilaen: {
                    name: "Jubliäenliste drucken",
                    disabled: false,
                    isBusy: false,
                    action: this.printAnniversary
                },
                aufnahmeAntrag: {
                    name: "Aufnahmeantrag drucken",
                    disabled: false,
                    isBusy: false,
                    action: this.printRegistrationForm
                }
            }
        };
    },
    created() {
      this.honorarBescheinigungsYears();
      this.mitgliedausweisYears();
    },
    mounted() {
        this.$root.$on("mv::mitglieder::fields::changed", fields => {
            this.fields = fields;
        });
        this.$root.$on("mv::mitglieder::filter::changed", filter => {
            this.filter = filter;
        });
    },
    computed: {
        size() {
            const settings = this.$store.getters.getSettings;
            return settings.size;
        }
    },
    methods: {
        selectNewsletter() {
            this.$root.$emit("bv::show::modal", "newsletterModal");
        },
        honorarBescheinigungsYears() {
            const date = new Date();
            let currYear = date.getFullYear();
            let startDate = currYear - 10;
            let enddate = currYear;

            let options = [];
            while (startDate <= enddate) {
                options.push({key: String(startDate), text: String(startDate)});
                startDate++;
            }
            this.functions.honorarbescheinigung.options = options;
        },
        mitgliedausweisYears() {
            const date = new Date();
            let currYear = date.getFullYear();
            let startDate = currYear - 1;
            let enddate = currYear + 1;

            let options = [];
            while (startDate <= enddate) {
                options.push({key: String(startDate), text: String(startDate)});
                startDate++;
            }
            this.functions.mitgliederausweis.options = options;
        },
        async printMitgliederliste(key, format) {
            MitgliederApi.abort();

            this.functions[key].isBusy = true;
            const response = await MitgliederApi.exportMitgliederliste(
                {
                    filter: this.filter
                },
                format
            );
            if (!response.ok) {
                // todo: Errorhandling
            } else {
                BlobUtil.downloadBlob(response.blob, "Mitgliederliste.pdf");
            }
            this.functions[key].isBusy = false;
        },
        async downloadExport(key, format) {
            MitgliederApi.abort();

            this.functions[key].isBusy = true;
            const response = await MitgliederApi.exportExcel(
                {
                    fields: this.fields,
                    filter: this.filter
                },
                format
            );
            if (!response.ok) {
                // todo: Errorhandling
            } else {
                BlobUtil.downloadBlob(response.blob, "export." + format);
            }
            this.functions[key].isBusy = false;
        },
        async printMitgliederausweise(key, year) {
            MitgliederApi.abort();

            this.functions[key].isBusy = true;

            let filter = this.$store.getters.getPages.mitglieder.filter;

            let params = {};
            if(!filter) {
                params = {
                    filter: {
                        mitgliedausweisYear: year }
                }
            } else {
                params = {
                    filter: {
                        ...filter,
                        ...{ mitgliedausweisYear: year }
                    }
                }
            }

            const response = await MitgliederApi.exportMitgliederausweise(params);
            if (!response.ok) {
                // todo: Errorhandling
            } else {
                BlobUtil.downloadBlob(response.blob, "Mitgliederausweise.pdf");
            }
            this.functions[key].isBusy = false;
        },
        async printAnniversary(key, type) {
            MitgliederApi.abort();

            this.generalFunctions[key].isBusy = true;
            const response = await MitgliederApi.exportAnniversary(type);
            if (!response.ok) {
                // todo: Errorhandling
            } else {
                BlobUtil.downloadBlob(response.blob, key + ".pdf");
            }
            this.generalFunctions[key].isBusy = false;
        },
        async printRegistrationForm(key) {
            MitgliederApi.abort();

            this.generalFunctions[key].isBusy = true;
            const response = await MitgliederApi.exportRegistrationForm();
            if (!response.ok) {
                // todo: Errorhandling
            } else {
                BlobUtil.downloadBlob(response.blob, "Anmeldeformular.pdf");
            }
            this.generalFunctions[key].isBusy = false;
        },
        async printHonorarbescheinigungen(key, year) {
            MitgliederApi.abort();

            this.functions[key].isBusy = true;

            let filter = this.$store.getters.getPages.mitglieder.filter;

            let params = {};
            if(!filter) {
                params = {
                    filter: {
                        honoraryear: year }
                }
            } else {
                params = {
                    filter: {
                        ...filter,
                        ...{ honoraryear: year }
                    }
                }
            }

            const response = await MitgliederApi.getHonorarBuchungen(params);

            if (!response.ok) {
                this.makeToast(
                    'Keine Datensätze gefunden',
                    'Für die getroffene Auswahl konnten keine Datensätze gefunden werden.',
                    'danger'
                );
            } else {
                BlobUtil.downloadBlob(response.blob, "Honorarbescheinigungen.pdf");
            }

            this.functions[key].isBusy = false;
        }
    }
};
</script>
